import WeightDistributeConfig from "@/views/Quota/DoubleInspection/WeightDistributeConfig";

const quota = {
    basePersonTypePage: '/base_person_type/page',
    basePersonTypeSave: '/base_person_type/save',
    basePersonTypeUpdate: '/base_person_type/update',
    doubleInspectionQuery: '/base_assess_weight_conf/list',
    doubleInspectionDelete: '/base_assess_weight_conf/delete',
    doubleInspectionSave: '/base_assess_weight_conf/save',
    doubleInspectionUpdate: '/base_assess_weight_conf/update',
    weightDistributeList: '/base_assess_weight_type/list',
    weightDistributeSave: '/base_assess_weight_type/save',
    weightDistributeUpdate: '/base_assess_weight_type/update',
    baseIndexModelPage: '/base_index_model/page',
    baseIndexModelSave: '/base_index_model/save',
    baseIndexModelUpdate: '/base_index_model/update',
    baseIndexModelInfo: '/base_index_model/info',
    baseIndexModelStandardConfList: '/base_index_model_standard_conf/list',
    basePersonTypeList: '/base_person_type/list',
    baseIndexModelList: '/base_index_model/list',
    baseIndexModelList2: '/base_person_type/model/list',
    baseIndexModelJudge:'/base_index_model/judge',
    baseIdexModelStandardConfSave: '/base_index_model_standard_conf/save',
    baseIdexModelStandardConfUpdate: '/base_index_model_standard_conf/update',
    baseIndexModelStandardConfDelete: '/base_index_model_standard_conf/delete',
    baseIndexInfoPage: '/base_index_info/page',
    baseIndexInfoSave: '/base_index_info/save',
    baseIndexInfoUpdate: '/base_index_info/update',
    baseIndexInfoInfo: '/base_index_info/info',
    baseIndexInfoDelete: '/base_index_info/delete',
    baseIndexComposePage: '/base_index_compose/page',
    baseIndexComposeSave: '/base_index_compose/save',
    baseIndexComposeUpdate: '/base_index_compose/update',
    baseIndexComposeDelete: '/base_index_compose/delete',
    baseIndexComposeInfo:'/base_index_compose/info',
    executiveList:'/base_senior_manager/page',
    executiveUpdate:'/base_senior_manager/update',
    executiveSave:'/base_senior_manager/save',
    executiveDelete:'/base_senior_manager/delete',
    annualBonusTemplate:'/base_senior_manager_template/list',
    baseKpiConfList: '/base_kpi_conf/list',
    baseKpiConfSave: '/base_kpi_conf/save',
    baseIndexInfoJudge: '/base_index_info/judge',
    baseIndexModelStandardAimList: '/base_index_model_standard_aim/list',
    baseIndexModelStandardAimSave: '/base_index_model_standard_aim/save',
    baseManagerTargetPage: '/base_manager_target/page',
    baseManagerTargetSave: '/base_manager_target/save',
    baseManagerTargetUpdate: '/base_manager_target/update',
    baseManagerTargetDelete: '/base_manager_target/delete',
    commonLinkPage: '/commonLink/page',
    commonLinkSave: '/commonLink/save',
    commonLinkSubmit: '/commonLink/submit',
    commonLinkUpdate: '/commonLink/update',
    commonLinkDelete: '/commonLink/delete',
    commonLinkInfo: '/commonLink/info',
    commonLinkType: '/commonLink/commonLinkType',
    baseIndexInfoGetAppliablePersonId: '/base_index_info/getAppliablePersonId',
    basePersonTypeAssessTemplate: '/base_person_type/assessTemplate',
    baseIndexInfoGetStatus: '/base_index_info/getStatus',
    baseIndexInfoGetAssessType: '/base_index_info/getAssessType',
    baseIndexInfoGetClassidication: '/base_index_info/getClassidication',
    baseIndexInfoGetYesNoEnum: '/base_index_info/getYesNoEnum',
    baseIndexInfoGetPersonSub: '/base_index_info/getPersonSub',
    baseIndexInfoGetComputeMethod: '/base_index_info/getComputeMethod',
    targetInfo: '/base_manager_target/list',
    funcFlowObjectManagerInfoGetKpiCycle: '/func_flow_object_manager_info/getKpiCycle',
    assessGroupDeptList: '/assessGroupDept/list',
    assessGroupDeptUpdate: '/assessGroupDept/update',
    assessGroupForceRulePage: '/assessGroupForceRule/page',
    assessGroupForceRuleInfo: '/assessGroupForceRule/info',
    assessGroupForceRuleDelete: '/assessGroupForceRule/delete',
    assessGroupForceRuleSave: '/assessGroupForceRule/save',
    assessGroupForceRuleEnable: '/assessGroupForceRule/enable',
    assessGroupYearPage: '/assessGroupYear/page',
    assessGroupYearCurrentForceRule: '/assessGroupYear/getCurrentForceRule',
    assessGroupYearInfo: '/assessGroupYear/info',
    assessGroupYearGroupName: '/assessGroupYear/getYearGroupName',
    assessGroupYearSave: '/assessGroupYear/save',
    assessGroupYearUpdate: '/assessGroupYear/update',
    assessGroupYearIsChanged: '/assessGroupYear/isChanged',
    assessGroupYearDelete: '/assessGroupYear/delete',
    assessGroupSettingPage: '/assessGroupSetting/page',
    assessGroupSettingUpdate: '/assessGroupSetting/update',
    getBaseAssessGroupMap: '/assessGroupYear/getBaseAssessGroupMap',
    userBonusLimitPage: '/userBonusLimit/page',
    userBonusLimitUpdate: '/userBonusLimit/update',
    // /sys/dict/data/list
}

export default quota